import React from "react";
import ReactLogo from "../icons/protectdotngo-logo.png";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer-burrito w-full">
      <footer className="footer-site max-w-full xl:max-w-7xl grid mt-16 ml-auto mr-auto py-16 text-sm text-white items-center gap-4">
        <div className="text-center">
          <p className="md:text-left">
            <strong>Contact Us</strong>
          </p>
          <dl className="md:text-left">
            <dt>
              <strong>Media Contact</strong>
            </dt>
            <dd>
              <a className="hover:text-cpi" href="mailto:media@protect.ngo">
                media@protect.ngo
              </a>
            </dd>
            <dt>
              <strong>General Enquiries</strong>
            </dt>
            <dd>
              <a className="hover:text-cpi" href="mailto:cit@protect.ngo">
                cit@protect.ngo
              </a>
            </dd>
          </dl>
        </div>

        <div></div>

        <div className="footer-logo flex justify-center">
          <img className="h-16 w-auto" src={ReactLogo} alt="Home" />
        </div>

        <div className="footer-copyright text-xs flex flex-col items-center md:items-start">
          <div>© Protect.ngo foundation.</div>
          <div>All rights reserved.</div>
        </div>

        <div className="footer-social flex flex-col items-center md:items-end">
          <div className="flex">
            <a
              className="footer-icon"
              href="https://www.linkedin.com/company/protect-ngo"
              rel="noreferrer"
              target="_blank"
              title="Join us on LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#ffffff"
              >
                <path d="M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"></path>
              </svg>
            </a>
            <a
              className="footer-icon"
              href="https://bsky.app/profile/protectngo.bsky.social"
              rel="noreferrer"
              target="_blank"
              title="Join us on Bluesky"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#ffffff"
              >
                <path d="M12 11.3884C11.0942 9.62673 8.62833 6.34423 6.335 4.7259C4.13833 3.17506 3.30083 3.4434 2.75167 3.69256C2.11583 3.9784 2 4.95506 2 5.52839C2 6.10339 2.315 10.2367 2.52 10.9276C3.19917 13.2076 5.61417 13.9776 7.83917 13.7309C4.57917 14.2142 1.68333 15.4017 5.48083 19.6292C9.65833 23.9542 11.2058 18.7017 12 16.0392C12.7942 18.7017 13.7083 23.7651 18.4442 19.6292C22 16.0392 19.4208 14.2142 16.1608 13.7309C18.3858 13.9784 20.8008 13.2076 21.48 10.9276C21.685 10.2376 22 6.10256 22 5.52923C22 4.95423 21.8842 3.97839 21.2483 3.6909C20.6992 3.44256 19.8617 3.17423 17.665 4.72423C15.3717 6.34506 12.9058 9.62756 12 11.3884Z"></path>
              </svg>
            </a>
          </div>
          {/*<div>Privacy Policy</div>*/}
        </div>
      </footer>
    </div>
  );
}
